import { getFormDataForSubmission } from './get-submission-form-data'
import { parseFormData, parseFormDataClientSide } from './zod-helpers'
import { HeadlessFormV2Root } from './form-root'
import { HeadlessFormV2GlobalProvider, useServerErrors } from './global-form-context'
import { HiddenFileInput } from './hidden-file-input'
import { HiddenInput } from './hidden-input'
import { HiddenSelect } from './hidden-select'
import { HiddenTextArea } from './hidden-text-area'
import { useControlledState } from './use-controlled-state'
import { useTopLevelFormValidation } from './use-form'
import { useFormReset } from './use-form-reset'
import { useFormValidation } from './use-form-validation'
import { useFormWarningState } from './use-form-warning-state'
import { ValidationFunction } from './validation-types'

export type { ValidationFunction, ValidationResult } from './validation-types'
export type { ParseFormDataOptions, ParseFormDataResult, FormDataWithFileHandled } from './zod-helpers'
export type { HeadlessFormV2Props } from './form-root'

function composeValidators<T>(...fns: (ValidationFunction<T> | undefined | null)[]): ValidationFunction<T> {
  return (value: T) => {
    const errors = fns.flatMap((f) => (f ? f(value) : [])).filter(Boolean) as string[]
    return errors
  }
}

export const HeadlessFormV2 = Object.assign(HeadlessFormV2Root, {
  HeadlessFormV2GlobalProvider,
  useFormValidation,
  useFormWarningState,
  useFormReset,
  useControlledState,
  HiddenInput,
  HiddenFileInput,
  HiddenSelect,
  HiddenTextArea,
  useServerErrors,
  parseFormDataClientSide: parseFormDataClientSide,
  parseFormData: parseFormData,
  getFormDataForSubmission,
  useTopLevelFormValidation,
  composeValidators
})
